<template>
  <div v-if="mountedPopup">
    <div
      v-show="isPopupShowing"
      class="questionnaire-popup"
      :class="{'questionnaire-popup--max-height custom-scrollbar': isMaxHeight}"
    >
      <FormQuestions
        ref="formQuestions"
        @submit="closePopup"
        get-questions-endpoint="/cabinet/questionnaire/part-info/?number_of_questions=1"
        post-questions-endpoint="/cabinet/questionnaire/result/"
        simple-question
        questionnaire
      />
      <button @click="closePopup" class="questionnaire-popup__close" :aria-label="$t('modal_close')"></button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FormQuestions from './FormQuestions'

export default {
  name: 'QuestionnairePopup',
  components: { FormQuestions },
  props: {
    delayShowing: {
      type: Number,
      default: 10000
    }
  },
  data () {
    return {
      mountedPopup: false,
      isPopupClosing: false,
      askAboutQuestionnaire: window?.['config']?.['questionnaire']?.['ask_about_questionnaire'] || false,
      isMaxHeight: false
    }
  },
  computed: {
    ...mapState('questionnaire', ['loadingData', 'sendInfo', 'polls']),
    isPopupShowing () {
      return this.polls && !this.loadingData && !this.isPopupClosing
    }
  },
  methods: {
    closePopup () {
      this.isPopupClosing = true
    },
    checkFormHeight () {
      const formQuestionsHeight = this.$refs.formQuestions.$el.clientHeight
      const baseHeight = 400

      if (formQuestionsHeight > baseHeight) {
        this.isMaxHeight = true
      }
    }
  },
  mounted () {
    if (this.askAboutQuestionnaire) {
      setTimeout(() => {
        this.mountedPopup = true
      }, this.delayShowing)
    }
  },
  watch: {
    isPopupShowing () {
      setTimeout(this.checkFormHeight)
    }
  }
}
</script>

<style scoped lang="sass">
.questionnaire-popup
  position: fixed
  left: 10px
  right: 10px
  bottom: 73px
  background-color: #fff
  padding: 20px 20px 15px
  box-shadow: 0 0 11px rgba(0, 0, 0, 0.2)
  border-radius: 3px
  z-index: 5

  &--max-height
    max-height: 60vh
    overflow-y: auto

    +mmin($tablet)
      max-height: 100%

  +mmin($extsmall--hor)
    left: auto
    width: 100%
    max-width: 400px

  +mmin($tablet--hor)
    bottom: 10px
    padding: 25px 30px

.questionnaire-popup__close
  cursor: pointer
  position: absolute
  display: block
  width: 20px
  height: 20px
  top: 20px
  right: 20px
  opacity: .3
  border: 0
  padding: 0
  background-color: transparent

  +mmin($tablet--hor)
    top: 25px
    right: 30px

  &:hover
    opacity: 1

  &:before,
  &:after
    content: ''
    position: absolute
    top: 0
    left: 50%
    height: 19px
    width: 2px
    background-color: #898989

  &:before
    transform: rotate(45deg)

  &:after
    transform: rotate(-45deg)

</style>
